import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import {
  ArticleCard,
  Heading,
  Loader,
  recordsContain,
} from '@frontendmentorio/design-system-v2';

import Downloads from './Downloads';
import LockedCard from '../LockedCard';

export default function ChallengeDownloads({ articles, challenge }) {
  const currentUser = useSelector(selectCurrentUser);
  const isUnlocked = recordsContain(currentUser?.unlockedHubs, challenge);

  if (isUnlocked) {
    return (
      <>
        <Downloads challenge={challenge} />

        <div className="flex flex-col gap-6 items-center">
          <Heading level="2">Useful articles</Heading>

          {articles?.length > 0 ? (
            <ul className="gap-6 grid grid-cols-1 mobile:grid-cols-2 desktop:grid-cols-3">
              {articles.map((article) => (
                <ArticleCard
                  article={article}
                  href={`/articles/${article.slug}`}
                  key={article.id}
                />
              ))}
            </ul>
          ) : (
            <Loader className="py-11" />
          )}
        </div>
      </>
    );
  }

  return (
    <LockedCard CTA="Start challenge" href={`/challenges/${challenge.slug}`}>
      Start this challenge to access downloads
    </LockedCard>
  );
}
